import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class LogoButton extends Component {
  render() {
    return (
      <a className="site-logo" href="/">
        <img src="/themes/custom/module_box/src/images/Logo_UNIKATUM.svg" alt="unikatum-logo"/>
      </a>
    );
  }
}

LogoButton.propTypes = {};

export default LogoButton;
